
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/summer-slide-checkout",
      function () {
        return require("private-next-pages/summer-slide-checkout.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/summer-slide-checkout"])
      });
    }
  